<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="cusTypeName"
      label="客户类型"
      width="120"
      align="center"
    />
    <el-table-column
      prop="cycleRange"
      label="复购周期区间"
      width="120"
      align="center"
    />
    <el-table-column
      prop="paymentCount"
      label="付款人数"
      width="150"
      align="right"
    />
    <el-table-column
      prop="paymentCountRatio"
      label="付款人数占比"
      width="140"
      align="right"
    />
    <el-table-column
      prop="paymentAmount"
      label="付款金额"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="paymentAmountRatio"
      label="付款金额占比"
      min-width="140"
      align="right"
    />
    <el-table-column
      prop="paymentOrderCount"
      label="付款单量"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="paymentOrderCountRatio"
      label="付款单量占比"
      min-width="140"
      align="right"
    />
    <el-table-column
      prop="paymentItemCount"
      label="付款件数"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="paymentItemCountRatio"
      label="付款件数占比"
      min-width="140"
      align="right"
    />
    <el-table-column
      prop="customerUnitPrice"
      label="客单价"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="itemUnitPrice"
      label="件单价"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="orderUnitPrice"
      label="笔单价"
      min-width="120"
      align="right"
    />
  </el-table>
</template>

<script>
import { mapGetters } from "vuex";
import mixins from "../../mixins";
import Empty from "../../components/empty.vue";
export default {
  name: "repurchaseAnalysis",
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    ...mapGetters(["softwareInfo"]),
    hasPurchaseMemberCustType() {
      return this.softwareInfo.permissions ? this.softwareInfo.permissions.includes('yunqiBIReport:purchaseMemberCustType') : false;
    },
    countTable() {
      let data = [ ...this.tableData ];
      if (!this.hasPurchaseMemberCustType) {
        data = data.filter(item => ![7, 8].includes(item.cusType));
      }
      return data.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (key === "cusTypeName" || key === "cycleRange" || key === "cusType") {
            newRow[key] = row[key];
            return;
          }
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
    },
  },
  methods: {
    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 只对客户类型列进行合并
        const cusType = row.cusType;
        const cusTypeName = row.cusTypeName;
        const sameTypeRows = this.countTable.filter(
          (item) => item.cusTypeName === cusTypeName && item.cusType === cusType
        );
        if (
          rowIndex ===
          this.countTable.findIndex((item) => item.cusTypeName === cusTypeName && item.cusType === cusType)
        ) {
          // 如果是同类型的第一行，返回合并的行数
          return {
            rowspan: sameTypeRows.length,
            colspan: 1,
          };
        } else {
          // 其他行不显示
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>
